var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessDenied(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 120,
    viewBox: "0 0 94 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.1399 43.9826L50.1499 30.8926L36.6399 17.2827L22 15.1226L2 12.1826V42.4926C2 55.0826 5.27005 68.4126 11.8 82.5026C18.33 96.5826 26.6099 107.963 36.6399 116.653C43.6599 118.683 49.8299 118.393 55.1399 115.793C57.4199 114.673 59.53 113.143 61.49 111.183C62.49 110.183 63.42 109.103 64.25 107.963C68.94 101.643 71.28 93.1526 71.28 82.4926V52.1826L63.1399 43.9826ZM53.96 81.9326L43.1399 75.6826V88.1126L38.9099 85.6726L30.1499 80.6126V68.1826L29.8198 67.9926L19.3198 61.9326V47.0327L23.9399 49.7026L30.1499 53.2827V40.8526L39.3198 46.1426L41.6899 47.5126L43.1399 48.3526V60.7827L43.98 61.2726L50.1499 64.8326L53.96 67.0327V81.9326Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.96 70.2727V81.9327L43.1399 75.6827L51.5999 71.4527L53.96 70.2727Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1499 64.8327V70.6127L34.7 78.3427L30.1499 80.6127V68.1827L43.98 61.2727L50.1499 64.8327Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6899 47.5126L39.3198 48.7026L30.1499 53.2826V40.8525L39.3198 46.1426L41.6899 47.5126Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3198 48.7027V51.9327L26.29 58.4427L19.3198 61.9327V47.0327L23.9399 49.7027L30.1499 53.2827L39.3198 48.7027Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.98 61.2726L30.1499 68.1826L29.8198 67.9926L19.3198 61.9326L26.29 58.4426L39.3198 51.9326L43.1399 54.1326V60.7827L43.98 61.2726Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5999 71.4526L43.1399 75.6826V88.1125L38.9099 85.6725L30.1499 80.6125L34.7 78.3426L50.1499 70.6125L51.5999 71.4526Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6399 7.28265L36.6399 17.2827L22 15.1226L2 12.1826L22 2.18262L56.6399 7.28265Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.28 42.1826L71.28 52.1826L63.1399 43.9826L50.1499 30.8926L36.6399 17.2827L56.6399 7.28265L91.28 42.1826Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M91.28 42.1826V72.4926C91.28 85.0826 88.02 94.6426 81.49 101.183C79.58 103.103 77.52 104.613 75.3 105.713L55.1399 115.793C57.4199 114.673 59.53 113.143 61.49 111.183C62.49 110.183 63.42 109.103 64.25 107.963C68.94 101.643 71.28 93.1526 71.28 82.4926V52.1826L91.28 42.1826Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDenied);
export default __webpack_public_path__ + "static/media/access-denied.97a0308f2e593bd60477dcf45466ae3e.svg";
export { ForwardRef as ReactComponent };